import { RemoteAudioTrack as TwilioRemoteAudioTrack, RemoteVideoTrack as TwilioRemoteVideoTrack } from 'twilio-video';

import { logger } from '../../../../../datadog/logger';

type DetachTrackParameters = {
  track: TwilioRemoteAudioTrack | TwilioRemoteVideoTrack;
  element: HTMLAudioElement | HTMLVideoElement;
};

export function detachRemoteTrack({ track, element }: DetachTrackParameters) {
  try {
    track.detach(element);
    element.srcObject = null;
  } catch (error) {
    logger.warn('Failed to detach audio track', {}, error as Error);
  }
}
